// src/sections/SchienensystemSection.jsx
import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";

export default function SchienensystemSection({ selectedAnlageId }) {
  const options = ["einlagig", "zweilagig", "aufgestaendert", "andere"];
  const [checkedValues, setCheckedValues] = useState([]);

  // ✅ LOAD existing data
  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/schienensystem/anlage/${selectedAnlageId}`)
      .then((res) => {
        const data = res.data;
        const loaded = [];

        if (data.einlagig) loaded.push("einlagig");
        if (data.zweilagig) loaded.push("zweilagig");
        if (data.aufgestaendert) loaded.push("aufgestaendert");
        if (data.andere) loaded.push("andere");

        setCheckedValues(loaded);
      })
      .catch(() => setCheckedValues([]));
  }, [selectedAnlageId]);

  const handleSave = async () => {
     if (!selectedAnlageId) return; // ✅ ADD THIS LINE
    const checked = checkedValues;

    const payload = {
      anlage: { id: selectedAnlageId },
      einlagig: checked.includes("einlagig"),
      zweilagig: checked.includes("zweilagig"),
      aufgestaendert: checked.includes("aufgestaendert"),
      andere: checked.includes("andere"),
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/schienensystem/anlage/${selectedAnlageId}`
      );

      if (!res.data?.id) {
        throw new Error("NO_EXISTING");
      }

      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/schienensystem/${res.data.id}`,
        payload
      );

      showSuccess("Gespeichert", "Schienensystem wurde aktualisiert");
    } catch {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/schienensystem`,
          payload
        );

        showSuccess("Gespeichert", "Schienensystem wurde gespeichert");
      } catch {
        showError("Fehler", "Schienensystem konnte nicht gespeichert werden");
      }
    }
  };

  return (
       <Box 
         p={8} 
         bg="white" 
         borderRadius="xl" 
         boxShadow="md" 
         mt={6} 
         mb={10} 
         maxW="fit-content"
       >
      <h3
        style={{
          marginBottom: 16,
          color: "#000000",
          fontWeight: "700",
          textTransform: "uppercase",
          marginLeft: 0,
          fontSize: "24px"
        }}
      >
        SCHIENENSYSTEM
      </h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "grid",
          gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
          gap: 12,
        }}
      >
        {options.map((opt) => (
          <label
            key={opt}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <input
              type="checkbox"
              value={opt}
              checked={checkedValues.includes(opt)}
              onChange={(e) =>
                setCheckedValues((prev) =>
                  e.target.checked
                    ? [...prev, opt]
                    : prev.filter((v) => v !== opt)
                )
              }
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <Button
        type="button"
         bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}
      >
        Speichern Schienensystem
      </Button>
       </Box>
  );
}